interface SectionTitleProps {
  title: string;
  subtitle?: string;
  action?: { label: string; href: string };
  align?: 'left' | 'center';
  light?: boolean;
}

export default function SectionTitle({ title, subtitle, action, align = 'left', light = false }: SectionTitleProps) {
  return (
    <div className={`mb-8 md:mb-10 ${align === 'center' ? 'text-center' : ''}`}>
      <div className={`flex items-center gap-2 mb-3 ${align === 'center' ? 'justify-center' : ''}`}>
        <div className="w-2 h-2 rounded-full bg-primary-500" />
        <span className={`text-xs font-semibold tracking-wider uppercase ${light ? 'text-background-300' : 'text-primary-600'}`}>
          {subtitle || '热门推荐'}
        </span>
      </div>
      <div className={`flex items-end justify-between ${align === 'center' ? 'justify-center' : ''}`}>
        <h2 className={`text-2xl md:text-3xl font-bold tracking-tight ${light ? 'text-background-50' : 'text-foreground-900'}`}>
          {title}
        </h2>
        {action && (
          <a
            href={action.href}
            className={`hidden sm:flex items-center gap-1 text-sm font-medium transition-colors ${
              light ? 'text-background-300 hover:text-background-50' : 'text-primary-600 hover:text-primary-700'
            }`}
          >
            {action.label}
            <i className="ri-arrow-right-line" />
          </a>
        )}
      </div>
    </div>
  );
}